// @ts-nocheck
import { FC } from "react";
import styled from "styled-components";
import colors from "../../../styles/colors";

interface ImportanceBarProps {
    value: number;
}

interface FlagProps {
    type?: 'no_contest' | 'dq' | string;
}

interface TeamContainerProps {
    isWinner?: boolean | number;
}

interface TeamLabelProps {
    isWinner?: boolean | number;
}

const MatchesContainer = styled.div`
    width: 100%;
    margin-top: 30px;
    padding-top: 30px;
    border-top: 2px solid rgba(255, 215, 0, 0.3);
`;

const MatchesTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: gold;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 20px;
`;

const WarningInfoBox = styled.div`
    background-color: rgba(255, 193, 7, 0.15);
    border: 2px solid #ffc107;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
    color: #ffc107;
    font-size: 14px;
    line-height: 1.6;

    strong {
        color: #ffc107;
        font-weight: 700;
        display: block;
        margin-bottom: 8px;
        font-size: 15px;
    }

    ul {
        margin: 10px 0;
        padding-left: 20px;

        li {
            margin: 8px 0;

            &:first-child {
                margin-top: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
`;

const MatchesGrid = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 25px;
    justify-content: flex-start;
    align-items: flex-start;
`;

const MatchCard = styled.div`
    max-width: 100%;
    padding: 20px;
    background-color: ${colors.bgColorBlack};
    border: 2px solid rgba(255, 215, 0, 0.3);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

const InfoSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const InfoLabel = styled.label`
    font-size: 16px;
    font-weight: 600;
    color: gold;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const InfoValue = styled.div`
    font-size: 16px;
    color: white;
    line-height: 1.6;
    padding: 10px;
    background-color: ${colors.bgColorBlack2};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const MatchHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const MatchTypeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const MatchTypeLabel = styled.span`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const MatchTypeValue = styled.span`
    font-size: 18px;
    font-weight: 600;
    color: gold;
    text-transform: uppercase;
`;

const MatchBeltContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background-color: ${colors.bgColorBlack2};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const BeltImage = styled.img`
    width: 40px;
    height: 40px;
    object-fit: contain;
`;

const BeltName = styled.span`
    font-size: 14px;
    color: white;
    font-weight: 500;
`;

const ImportanceContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 10px;
    background-color: ${colors.bgColorBlack2};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    min-width: 120px;
`;

const ImportanceLabel = styled.span`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const ImportanceValue = styled.span`
    font-size: 18px;
    font-weight: 600;
    color: gold;
    text-align: center;
`;

const ImportanceBarContainer = styled.div`
    width: 100%;
    height: 8px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    overflow: hidden;
    margin-top: 5px;
`;

const ImportanceBar = styled.div<ImportanceBarProps>`
    height: 100%;
    background: linear-gradient(90deg, #4CAF50 0%, #8BC34A 50%, #FFC107 75%, #FF5722 100%);
    width: ${props => (props.value / 10) * 100}%;
    transition: width 0.3s ease-in-out;
    border-radius: 4px;
`;

const MatchFlagsContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
`;

const Flag = styled.span<FlagProps>`
    padding: 6px 12px;
    background-color: ${props => props.type === 'no_contest' ? '#ff9800' : '#f44336'};
    color: white;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const TeamsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

const TeamContainer = styled.div<TeamContainerProps>`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 5px;
    background-color: ${props => props.isWinner ? 'rgba(0, 255, 0, 0.1)' : 'rgba(255, 255, 255, 0.05)'};
    border: 2px solid ${props => props.isWinner ? 'rgba(0, 255, 0, 0.5)' : 'rgba(255, 255, 255, 0.1)'};
    border-radius: 5px;
`;

const TeamLabel = styled.div<TeamLabelProps>`
    font-size: 14px;
    font-weight: 600;
    color: ${props => props.isWinner ? '#4CAF50' : 'rgba(255, 255, 255, 0.8)'};
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const WrestlersList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
`;

const WrestlerItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background-color: ${colors.bgColorBlack2};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const WrestlerAvatar = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid rgba(255, 215, 0, 0.3);
`;

const WrestlerName = styled.span`
    font-size: 14px;
    color: white;
    font-weight: 500;
`;

const MatchNotes = styled.div`
    padding: 10px;
    background-color: ${colors.bgColorBlack2};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    font-style: italic;
    line-height: 1.6;
`;

const AddMatchButton = styled.button`
    padding: 12px 24px;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    border: 2px solid gold;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
    margin: 20px auto 0;
    display: block;

    &:hover {
        transform: scale(1.05);
        background-color: ${colors.bgColorRed};
    }

    &:active {
        transform: scale(0.98);
    }
`;

const MatchActionsContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    justify-content: flex-end;
    flex-wrap: wrap;
`;

const EditMatchButton = styled.button`
    padding: 8px 16px;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    border: 2px solid gold;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;

    &:hover {
        transform: scale(1.05);
        background-color: ${colors.bgColorRed};
    }

    &:active {
        transform: scale(0.98);
    }
`;

const DeleteMatchButton = styled.button`
    padding: 8px 16px;
    background-color: #dc3545;
    color: white;
    border: 2px solid #dc3545;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;

    &:hover:not(:disabled) {
        transform: scale(1.05);
        background-color: #c82333;
        border-color: #c82333;
    }

    &:active:not(:disabled) {
        transform: scale(0.98);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

interface Wrestler {
    id: number;
    name: string;
    avatar_path?: string;
}

interface Team {
    is_winner?: boolean | number;
    wrestlers?: Wrestler[];
}

interface Belt {
    id: number;
    name: string;
    img_path?: string;
}

interface TypeMatch {
    name?: string;
}

interface Fight {
    id: number;
    type_match?: TypeMatch;
    belt?: Belt;
    importance?: number | null;
    is_no_contest?: number;
    win_by_dq?: number;
    teams?: Team[];
    notes?: string;
}

interface Props {
    fights?: Fight[];
    onAddMatchClick?: () => void;
    onEditMatchClick?: (fight: Fight) => void;
    onDeleteMatchClick?: (fight: Fight) => void;
}

const PpvSpecificMatchList: FC<Props> = ({ fights, onAddMatchClick, onEditMatchClick, onDeleteMatchClick }) => {
    const hasFights = fights && Array.isArray(fights) && fights.length > 0;

    if (!hasFights && !onAddMatchClick) {
        return null;
    }

    return (
        <MatchesContainer className="ppv-specific-match-list-container">
            <MatchesTitle className="ppv-specific-match-list-title">
                Lista Match
            </MatchesTitle>
            <WarningInfoBox className="ppv-specific-match-list-warning-box">
                <strong>⚠️ ATTENZIONE - Gestione Ordine Match</strong>
                <div>
                    <p style={{ margin: '8px 0' }}>
                        <strong>1. Ordine dei Match:</strong> Quando si inseriscono i match, è <strong>fondamentale</strong> inserirli nell'ordine corretto.
                        Anche se questo ordine non sarà visibile/recuperabile nella visione finale, è essenziale per il corretto funzionamento del sistema.
                    </p>
                    <p style={{ margin: '8px 0' }}>
                        <strong>2. Problemi con Eliminazione e Reinserimento:</strong> Se si commette un errore su un singolo match e ci si accorge dopo,
                        <strong> NON eliminare e reinserire quel singolo match</strong>. Questa operazione potrebbe causare problemi all'albo d'oro e alla gestione dei titoli.
                    </p>
                    <p style={{ margin: '8px 0' }}>
                        <strong>3. Soluzioni in caso di errore:</strong> Se si verifica che ci siano problemi, le uniche soluzioni sono:
                    </p>
                    <ul>
                        <li><strong>Opzione A:</strong> Eliminare <strong>TUTTI</strong> i match e ricominciare da zero</li>
                        <li><strong>Opzione B:</strong> Eliminare i match in ordine inverso, partendo dal <strong>Main Event</strong> fino al match da cancellare</li>
                    </ul>
                </div>
            </WarningInfoBox>
            {onAddMatchClick && (
                <AddMatchButton
                    onClick={onAddMatchClick}
                    className="ppv-specific-match-list-add-button-top"
                    style={{ marginBottom: '20px' }}
                >
                    Inserisci Match
                </AddMatchButton>
            )}
            {hasFights && (
                <MatchesGrid className="ppv-specific-match-grid">
                    {fights!.map((fight: any) => (
                    <MatchCard key={fight.id} className="ppv-specific-match-card">
                    <MatchHeader className="ppv-specific-match-header">
                        <MatchTypeContainer className="ppv-specific-match-type-container">
                            <MatchTypeLabel className="ppv-specific-match-type-label">Tipo Match</MatchTypeLabel>
                            <MatchTypeValue className="ppv-specific-match-type-value">
                                {fight.type_match?.name || 'Match'}
                            </MatchTypeValue>
                        </MatchTypeContainer>
                        {fight.belt && (
                            <MatchBeltContainer className="ppv-specific-match-belt-container">
                                <BeltImage
                                    src={process.env.REACT_APP_STORAGE_URL + fight.belt.img_path}
                                    alt={fight.belt.name}
                                />
                                <BeltName>{fight.belt.name}</BeltName>
                            </MatchBeltContainer>
                        )}
                        <ImportanceContainer className="ppv-specific-match-importance-container">
                            <ImportanceLabel className="ppv-specific-match-importance-label">Importance</ImportanceLabel>
                            <ImportanceValue className="ppv-specific-match-importance-value">
                                {fight.importance !== undefined && fight.importance !== null ? fight.importance : 0}/10
                            </ImportanceValue>
                            <ImportanceBarContainer className="ppv-specific-match-importance-bar-container">
                                <ImportanceBar
                                    value={fight.importance !== undefined && fight.importance !== null ? fight.importance : 0}
                                    className="ppv-specific-match-importance-bar"
                                />
                            </ImportanceBarContainer>
                        </ImportanceContainer>
                    </MatchHeader>

                    {(fight.is_no_contest === 1 || fight.win_by_dq === 1) && (
                        <InfoSection className="ppv-specific-match-flags-section">
                            <InfoLabel className="ppv-specific-match-flags-label">Flag Speciali</InfoLabel>
                            <MatchFlagsContainer className="ppv-specific-match-flags-container">
                                {fight.is_no_contest === 1 && (
                                    <Flag type="no_contest" className="ppv-specific-match-flag">No Contest</Flag>
                                )}
                                {fight.win_by_dq === 1 && (
                                    <Flag type="dq" className="ppv-specific-match-flag">Win by DQ</Flag>
                                )}
                            </MatchFlagsContainer>
                        </InfoSection>
                    )}

                    <InfoSection className="ppv-specific-match-teams-section">
                        <InfoLabel className="ppv-specific-match-teams-label">Team</InfoLabel>
                        <TeamsContainer className="ppv-specific-match-teams-container">
                            {fight.teams && Array.isArray(fight.teams) && fight.teams.map((team, teamIndex) => (
                                <TeamContainer
                                    key={teamIndex}
                                    isWinner={team.is_winner}
                                    className="ppv-specific-match-team-container"
                                >
                                    <TeamLabel isWinner={team.is_winner} className="ppv-specific-match-team-label">
                                        {team.is_winner ? '✓ VINCITORE' : '✗ Sconfitto'}
                                    </TeamLabel>
                                    <WrestlersList className="ppv-specific-match-wrestlers-list">
                                        {team.wrestlers && Array.isArray(team.wrestlers) && team.wrestlers.map((wrestler: any) => (
                                            <WrestlerItem key={wrestler.id} className="ppv-specific-match-wrestler-item">
                                                <WrestlerAvatar
                                                    src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path}
                                                    alt={wrestler.name}
                                                />
                                                <WrestlerName>{wrestler.name}</WrestlerName>
                                            </WrestlerItem>
                                        ))}
                                    </WrestlersList>
                                </TeamContainer>
                            ))}
                        </TeamsContainer>
                    </InfoSection>

                    {fight.notes && (
                        <InfoSection className="ppv-specific-match-notes-section">
                            <InfoLabel className="ppv-specific-match-notes-label">Note</InfoLabel>
                            <MatchNotes className="ppv-specific-match-notes">
                                {fight.notes}
                            </MatchNotes>
                        </InfoSection>
                    )}

                    {(onEditMatchClick || onDeleteMatchClick) && (
                        <MatchActionsContainer className="ppv-specific-match-actions-container">
                            {onEditMatchClick && (
                                <EditMatchButton
                                    onClick={() => onEditMatchClick(fight)}
                                    className="ppv-specific-match-edit-button"
                                >
                                    Modifica
                                </EditMatchButton>
                            )}
                            {onDeleteMatchClick && (
                                <DeleteMatchButton
                                    onClick={() => onDeleteMatchClick(fight)}
                                    className="ppv-specific-match-delete-button"
                                >
                                    Elimina
                                </DeleteMatchButton>
                            )}
                        </MatchActionsContainer>
                    )}
                    </MatchCard>
                    ))}
                </MatchesGrid>
            )}
            {onAddMatchClick && (
                <AddMatchButton
                    onClick={onAddMatchClick}
                    className="ppv-specific-match-list-add-button"
                >
                    Inserisci Match
                </AddMatchButton>
            )}
        </MatchesContainer>
    );
};

export default PpvSpecificMatchList;
